import Clarity from '@microsoft/clarity';
import { useUserStore } from '@/stores/user';

export default defineNuxtPlugin((nuxtApp) => {
    const id = nuxtApp.$config.public.clarityId
    const featureEnabled = nuxtApp.$config.public.features.clarity
    const useClarityInImpersonationMode = nuxtApp.$config.public.features.clarityInImpersonationMode;
    const userStore = useUserStore()
    
    if(!featureEnabled) {
        console.log("Clarity feature is not enabled")
        return;
    }
    
    if(!useClarityInImpersonationMode && userStore.isImpersonating) {
        console.log("Clarity is not loaded in impersonation mode")
        return;
    }
    
    // Only initialize if ID is present
    if (id) {
        setTimeout(() => {
            Clarity.init(id)
        }, 4000);
        console.log('Clarity initialized')
    } else {
        console.log('Clarity disabled (no ID provided)')
    }
})